import { render, staticRenderFns } from "./tnc-id.vue?vue&type=template&id=7fbf25f0&scoped=true"
import script from "./tnc-id.vue?vue&type=script&lang=js"
export * from "./tnc-id.vue?vue&type=script&lang=js"
import style0 from "./tnc-id.vue?vue&type=style&index=0&id=7fbf25f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf25f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbf25f0')) {
      api.createRecord('7fbf25f0', component.options)
    } else {
      api.reload('7fbf25f0', component.options)
    }
    module.hot.accept("./tnc-id.vue?vue&type=template&id=7fbf25f0&scoped=true", function () {
      api.rerender('7fbf25f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-id.vue"
export default component.exports